/**
 * Where the source code of Bridge lives. The header button already wears the
 * GitHub mark for the day the code moves to GitHub: then only this address
 * changes, and the file links below follow it.
 */
export const SOURCE_URL = 'https://bitbucket.org/passworkteam/passwork-bridge';

/** A file on the main branch, in the form the host uses. */
export function sourceFile(path: string): string {
  return SOURCE_URL.includes('github.com') ? `${SOURCE_URL}/blob/main/${path}` : `${SOURCE_URL}/src/main/${path}`;
}

/** The README of the main branch, where the docs start. */
export const README_URL = sourceFile('README.md');
